import React from "react";

import { ColumnStyle, Steward } from "components/Common/TableStyle";

export const DOMAINS_COLUMNS = () => [
  {
    title: "Name",
    key: "name",
    dataIndex: "name",
    width: "25%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Description",
    key: "description",
    dataIndex: "description",
    width: "40%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "Drafter",
    key: "drafter",
    dataIndex: "drafter",
    width: "20%",
    render: (text, record) => (
      <Steward name={text} title={record.title || "Data Steward"} />
    ),
  },
  {
    title: "Approver",
    key: "approver",
    dataIndex: "approver",
    width: "30%",
    render: (text, record) => (
      <Steward name={text} title={record.title || "Data Steward"} />
    ),
  },
  {
    dataIndex: "cde",
    key: "cde",
    title: "#CDE",
    width: "20%",
    render: text => <ColumnStyle text={text} />,
  },
  {
    title: "# Data Source",
    key: "data_source",
    dataIndex: "data_source",
    width: "30%",
    render: text => <ColumnStyle text={text} />,
  },
];

export const DOMAINS_DATA = [
  {
    id: 1,
    name: "Patient",
    description: "Patient domain",
    drafter: "Debbie",
    approver: "Jack Smith",
    cde: "16",
    data_source: "4",
  },
  {
    id: 2,
    name: "Provider",
    description: "Provider details",
    drafter: "Debbie",
    approver: "Jack Smith",
    cde: "22",
    data_source: "3",
  },
];
